import React, { useState } from 'react';

import { Button, Tag } from 'antd';
import styles from './index.module.scss';
import { useArticleContext } from '../../context';
import { SortType } from '../../../../Pages/SearchResults';

export interface SelectedFiltersProps {
  isFilter?: boolean;
}

export default function SelectedFilters({ isFilter }: SelectedFiltersProps): React.ReactNode | null {
  const {
    filters, categories, subCategories, categoryLoading, setFilters, setSortValue,
  } = useArticleContext();

  return (
    <div>
      {(filters?.categoryId?.length
        || filters?.subCategoryId?.length || filters?.types?.length || filters?.tags?.length)
        ? (
          <div className={styles.wrapper} style={isFilter ? {} : { padding: 0, marginTop: 12 }}>
            {
              isFilter
                ? <h4>Selected filters</h4>
                : null
            }
            <div style={{
              display: 'flex', flexWrap: 'wrap', gap: 8,
            }}
            >
              {isFilter
                ? null
                : (
                  <Button
                    type="primary"
                    onClick={() => {
                      setFilters?.({
                        categoryId: [],
                        subCategoryId: [],
                        types: [],
                        tags: [],
                      });
                      setSortValue?.(SortType.Newest);
                    }}
                    className={styles.clearAllBtn}
                  >
                    Clear all
                  </Button>
                )}
              {(filters?.categoryId ?? []).map((id) => {
                const name = categories?.find((c: { id: string; }) => c.id === id)?.name ?? id;

                return (
                  <Tag
                    className={styles.selectedItem}
                    key={`cat-${id}`}
                    closable
                    onClose={() => {
                      setFilters?.({
                        ...filters,
                        categoryId: filters.categoryId?.filter((i) => i !== id) ?? [],
                      });
                    }}
                  >
                    {name}
                  </Tag>
                );
              })}

              {(filters?.subCategoryId ?? []).map((id) => {
                const name = subCategories?.find((s) => s.id === id)?.name ?? id;

                return (
                  <Tag
                    className={styles.selectedItem}
                    key={`sub-${id}`}
                    closable
                    onClose={() => {
                      setFilters?.({
                        ...filters,
                        subCategoryId: filters.subCategoryId?.filter((i) => i !== id) ?? [],
                      });
                    }}
                  >
                    {name}
                  </Tag>
                );
              })}

              {(filters?.types ?? []).map((type) => (
                <Tag
                  className={styles.selectedItem}
                  key={`type-${type}`}
                  closable
                  onClose={() => {
                    setFilters?.({
                      ...filters,
                      types: filters.types?.filter((t) => t !== type) ?? [],
                    });
                  }}
                >
                  {type.charAt(0).toUpperCase() + type.slice(1)}
                </Tag>
              ))}
              {(filters?.tags ?? []).map((tag) => (
                <Tag
                  className={styles.selectedItem}
                  key={`tag-${tag}`}
                  closable
                  onClose={() => {
                    setFilters?.({
                      ...filters,
                      tags: filters.tags?.filter((t) => t !== tag) ?? [],
                    });
                  }}
                >
                  {tag}
                </Tag>
              ))}
            </div>
          </div>
        ) : null}
    </div>
  );
}
